import React, { useContext, useState, useMemo, useCallback } from 'react'
import PropTypes from 'prop-types'

import { DataContext } from '@aytm/app/stats/page/sidebar/coding/CodingPanel'

import { getCodeboksSentimentItemOptionsList } from '@aytm/app/stats/page/comments/lib/utils'

import SettingsButton from '@aytm/app/stats/page/sidebar/coding/components/SettingsButton'

import style from '@aytm/app/stats/page/sidebar/coding/styles/CodingPanel.module.scss'

const CodebookSettingsSentiment = ({
  codebookRef,
  codebook,
  opened = false,
  isProcessing = false,
  isCurrentProcessing = false,
  onConfirm
}) => {
  const { features, tagsList, isSentimentsDisabled, onAction, onToggleSettings } = useContext(DataContext)

  const [selectedAction, setSelectedAction] = useState(null)

  const onActionCancel = useCallback(() => setSelectedAction(null), [])

  const onActionConfirm = useCallback(() => {
    onConfirm(selectedAction)
  }, [selectedAction, onConfirm])

  const onActionClick = useCallback(
    action => {
      if ('assign' != action) setSelectedAction(action)
      if (onAction) onAction(action, codebook)
    },
    [codebook, onAction]
  )

  const options = useMemo(
    () =>
      getCodeboksSentimentItemOptionsList({
        codebook,
        selectedAction,
        tagsList,
        isSentimentsManagementDisabled: isSentimentsDisabled,
        isAiAssistantsOECodingDisabled: features.ai_assistants_stat_llm_sentiments.disabled,
        onActionCancel,
        onActionConfirm,
        onActionClick
      }),
    [
      codebook,
      selectedAction,
      tagsList,
      isSentimentsDisabled,
      features.ai_assistants_stat_llm_sentiments.disabled,
      onActionCancel,
      onActionConfirm,
      onActionClick
    ]
  )

  const onToggle = useCallback(() => onToggleSettings(codebook.codebook, codebook.type), [codebook, onToggleSettings])

  return 0 < options.length ? (
    <SettingsButton
      itemRef={codebookRef}
      options={options}
      opened={opened}
      isProcessing={isProcessing}
      isCurrentProcessing={isCurrentProcessing}
      onActionCancel={onActionCancel}
      onToggle={onToggle}
    />
  ) : (
    <div className={style['component-settings']}></div>
  )
}

CodebookSettingsSentiment.propTypes = {
  codebookRef: PropTypes.any,
  codebook: PropTypes.object,
  opened: PropTypes.bool,
  isProcessing: PropTypes.bool,
  isCurrentProcessing: PropTypes.bool,
  onConfirm: PropTypes.func
}

CodebookSettingsSentiment.displayName = 'CodebookSettingsSentiment'

export default CodebookSettingsSentiment
